import { createNamespacedHelpers } from 'vuex';
import _ from 'lodash';
import Storage from 'Shared/helpers/storageManager';
import { prepend } from '../utils';
import * as types from '../types';

const storageReferralCode = Storage.respondentReferralCode.get();

export const defaultState = {
  referralCode:
    _.get(window, 'pageParams.referralCode') || storageReferralCode || '',
  referrerName: _.get(window, 'pageParams.referrerName', ''),
};

export const namespace = 'referral';
export const helpers = createNamespacedHelpers(namespace);
export const prependNamespace = prepend(namespace);
export const mutations = {
  [types.SET_FIELDS]: _.merge,
};

export default {
  namespaced: true,
  state: { ...defaultState },
  mutations,
};
